import { useEffect, useRef, useState } from 'react';
import { experiments } from './index';
import { bucket, getOrCreateAnonId } from './bucket';
import { recordExposure } from './track';

function readPreviewVariant(name, validVariants) {
  if (typeof window === 'undefined' || !window.location) return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const requested = params.get('variant');
    if (requested && validVariants.indexOf(requested) !== -1) return requested;
  } catch (e) { /* noop */ }
  return null;
}

export function useExperiment(name) {
  const def = experiments[name];
  if (!def) {
    throw new Error(`useExperiment: unknown experiment "${name}"`);
  }

  const preview = readPreviewVariant(name, def.variants);

  const [variant] = useState(() => {
    if (preview) return preview;
    if (def.status !== 'running') return def.variants[0];
    const anonId = getOrCreateAnonId();
    return bucket(anonId, name, def.variants);
  });

  const exposed = useRef(false);
  useEffect(() => {
    if (exposed.current) return;
    exposed.current = true;
    if (preview) return;
    if (def.status === 'running') {
      recordExposure(name, variant);
    }
  }, [name, variant, def.status, preview]);

  return variant;
}

export function isPreviewMode() {
  if (typeof window === 'undefined' || !window.location) return false;
  try {
    return new URLSearchParams(window.location.search).has('variant');
  } catch (e) { return false; }
}
